import React, { useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../../components/Auth/AuthContext/AuthContext';
import { DisplayHeading } from '../../../components/editorial';
import EditorialAuthShell from '../../../components/EditorialAuthShell/EditorialAuthShell';

const SignOut: React.FC = () => {
  const { logout } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    const signOut = async () => {
      await logout();
      navigate('/');
    };
    signOut();
  }, [logout, navigate]);

  return (
    <EditorialAuthShell bloomSeed={3}>
      <DisplayHeading as="h1" scale="heading" measure={false} className="text-center">
        Signing you out
      </DisplayHeading>
      <p className="mt-4 text-editorial-body text-editorial-muted/70">
        One moment, we&apos;re signing you out and taking you home.
      </p>
    </EditorialAuthShell>
  );
};

export default SignOut;
